import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/userGroups'
import Component from 'components/UserGroups'

export default createListViewContainer({ actions, selectors: selectors.userGroups })(Component)
